import dayjs from 'dayjs';
import { arrayOf } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { useTheme } from 'styled-components';

import { TOTAL_BENCH } from 'constants/dashboardConstants';
import { benchGraphShape } from 'constants/shapes';

import GraphTooltip from './GraphTooltip';
import YAxisTick from './YAxisTick';

const BenchChart = ({ data }) => {
  const intl = useIntl();
  const theme = useTheme();

  const graphData = [
    {
      label: intl.formatMessage({ id: TOTAL_BENCH.intl }),
      dataKey: TOTAL_BENCH.key,
      color: TOTAL_BENCH.color,
      stroke: TOTAL_BENCH.stroke
    }
  ];

  return (
    <ResponsiveContainer minHeight={400} minWidth={500}>
      <AreaChart data={data} margin={{ top: 40, bottom: 40 }}>
        <CartesianGrid vertical={false} stroke={theme.new.colors.N300} />
        <XAxis
          dataKey={data?.length > 5 ? 'month' : 'quarter'}
          tickFormatter={tickItem =>
            data?.length > 5
              ? dayjs()
                  .month(tickItem - 1)
                  .format('MMM')
                  .toUpperCase()
              : `Q${tickItem}`
          }
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          tickLine={false}
          axisLine={false}
          tick={<YAxisTick />}
          domain={[0, 100]}
          ticks={[0, 20, 40, 60, 80, 100]}
        />
        <defs>
          <linearGradient id="benchColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6C3DF7" stopOpacity={1} />
            <stop offset="100%" stopColor="#A284F9" stopOpacity={0} />
          </linearGradient>
        </defs>
        <Tooltip content={content => <GraphTooltip isQuarter={data?.length < 5} {...content} />} />
        {graphData.map(({ dataKey, color, stroke, ...props }) => (
          <Area
            type="monotone"
            strokeWidth={3}
            stroke={stroke}
            key={dataKey}
            dataKey={dataKey}
            fill={color}
            {...props}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
};

BenchChart.propTypes = {
  data: arrayOf(benchGraphShape)
};

export default BenchChart;
